import React from 'react';
import useIsMobile from '../utils/useIsMobile';
import Cart from '../pages/Cart';
import Cart2 from '../pages/Cart2';

export default function CartDesignType() {
     const isMobile = useIsMobile();
  return (
    <div>
    {isMobile ?
     <React.Fragment>
        <Cart/>
         </React.Fragment>:
         <React.Fragment> 
        <Cart2/>
         </React.Fragment>}


    </div>
  )
}
